import { formatInTimeZone } from 'date-fns-tz';
import capitalize from 'lodash/capitalize';
import type { ServiceHealth } from '../types';

function formatCheck(check: ServiceHealth['check']) {
  if (!check) {
    return;
  }

  switch (check) {
    case 'graphqlIntrospection':
      return 'GraphQL Introspection';
    default:
      return check;
  }
}

function formatReasonCode(reasonCode: ServiceHealth['reasonCode']) {
  if (!reasonCode) {
    return;
  }

  switch (reasonCode) {
    case 'ok':
      return 'OK';
    case 'badRequest':
      return 'Bad Request';
    case 'rateLimited':
      return 'Rate Limited';
    case 'serverError':
      return 'Server Error';
    default:
      return capitalize(reasonCode);
  }
}

export function formatServiceHealth({ timezone }: { timezone: string }) {
  return (serviceHealth: ServiceHealth) => {
    const formattedTimestamp = formatInTimeZone(
      serviceHealth.timestamp ?? new Date(),
      timezone,
      'MMM d, yyyy h:mm a z'
    );
    const formattedCheck = formatCheck(serviceHealth.check);
    const formattedReasonCode = formatReasonCode(serviceHealth.reasonCode);

    return {
      ...serviceHealth,
      formattedTimestamp,
      formattedCheck,
      formattedReasonCode
    };
  };
}
